import axios from "axios";

// Old requests must not overwrite Redux after a newer company refresh starts.
let latestRequest = 0;

export const getOnlineUserViaRouterFunc = (url) => {
  return (dispatch) => {
    const requestId = ++latestRequest;
    dispatch({ type: "FETCH_ONLINEUSERVIAROUTER_REQUEST" });
    return axios.get("/getOnlineUser/api")
      .then((response) => {
        if (requestId !== latestRequest) return { ok: true, stale: true };
        dispatch({ type: "FETCH_ONLINEUSERVIAROUTER_SUCCESS", payload: response.data });
        return { ok: true };
      })
      .catch((error) => {
        if (requestId !== latestRequest) return { ok: true, stale: true };
        dispatch({ type: "FETCH_ONLINEUSERVIAROUTER_FAILURE", payload: error.message });
        // Preserve existing UI error action without unhandled promise rejections.
        return { ok: false, error };
      });
  };
};
